'use client';

import {CaptchaContextProvider} from '@shared/Captcha/Client/CaptchaContext';
import {PropsWithChildren} from 'react';

import {EnvConfig} from '@web-catalog/types';

import {useOmicronClientFlag} from '@web-catalog/hooks/omicron';

import {logTmrEvent} from '@web-catalog/utils/analytics/logEvent';

type Props = PropsWithChildren<{
  envConfig: EnvConfig;
}>;

export const CaptchaProvider = ({envConfig, children}: Props) => {
  const provider = useOmicronClientFlag('CAPTCHA_PROVIDER');
  const showCaptchaAfterSubmit = useOmicronClientFlag(
    'SHOW_CAPTCHA_AFTER_SUBMIT',
  );
  return (
    <CaptchaContextProvider
      allowBypassCaptcha={envConfig.ALLOW_BYPASS_CAPTCHA === 'true'}
      provider={provider}
      showCaptchaAfterSubmit={showCaptchaAfterSubmit}
      yandexSiteKey={envConfig.YANDEX_CAPTCHA_CLIENT_ID}
      vkInitEndpoint="/catalog/api/vk-captcha-init"
      logAnalyticsEvent={logTmrEvent}
    >
      {children}
    </CaptchaContextProvider>
  );
};
